/** @format */

import {styled} from '@mui/material/styles';
import {TableRow, TableRowProps} from '@mui/material';

const StyledTableBodyRow = styled((props: TableRowProps) => <TableRow {...props} />)(({theme}) => ({
  height: '36px',
  cursor: 'pointer',
  transition: 'background 0.2s',
  '&:hover': {
    background: theme?.palette.figma_gray_dark_1?.main,
  },
  '> .MuiTableCell-root:not(:last-of-type)': {
    borderRight: `1px solid ${theme.palette.figma_gray_dark_3?.main}`,
  },
  '> .MuiTableCell-root:nth-of-type(2)': {
    width: '40px',
  },
  '> .MuiTableCell-root:nth-of-type(3)': {
    width: '90px',
  },
  '> .MuiTableCell-root:nth-of-type(4)': {
    width: '200px',
  },
  [theme.breakpoints.down('md')]: {
    '> .MuiTableCell-root:nth-of-type(4)': {
      width: '56px',
    },
  },
}));

export {StyledTableBodyRow};
